<template>
  <secondary-overlay class="lg:px-60 px-5 pt-10 pb-20 m-auto items-center">
    <table class="text-left align-top text-white lg:w-1/2 w-full m-auto">
      <tr>
        <td>Cinematography:</td>
        <td>
          Liz Lambert<br />
          Jennifer Lane<br />
          Uta Briesewitz
        </td>
      </tr>
      <tr>
        <td>Original Score:</td>
        <td>Stephen Barber</td>
      </tr>
      <tr>
        <td>Sound Editing:</td>
        <td>Kathryn Korniloff</td>
      </tr>
      <tr>
        <td>Audio Post Production:</td>
        <td>Sonicfruit</td>
      </tr>
      <tr>
        <td>Additional Camera:</td>
        <td>
          Andy Cadelago<br />
          Marco Fiorillo<br />
          David Perez
        </td>
      </tr>
      <tr>
        <td>Assistant Editor:</td>
        <td>Luke Asa Giudici</td>
      </tr>
      <tr>
        <td>Music Producer:</td>
        <td>Stephen Barber</td>
      </tr>
      <tr>
        <td>Engineer:</td>
        <td>Chet Himes</td>
      </tr>
      <tr>
        <td>Assistant Engineer:</td>
        <td>
          Laurie Galbraith<br />
          Austin Music Studios (A.S.M.)
        </td>
      </tr>
      <tr>
        <td>Title Design:</td>
        <td>M. Wartella Dream Factory Animation</td>
      </tr>
      <tr>
        <td>Mix and Color:</td>
        <td>Stuck On On</td>
      </tr>
      <tr>
        <td>Post Producer:</td>
        <td>Allison Turrell</td>
      </tr>
      <tr>
        <td>Supervising Colorist:</td>
        <td>Parke Gregg</td>
      </tr>
      <tr>
        <td>Colorist:</td>
        <td>Alex Winker</td>
      </tr>
      <tr>
        <td>Dialogue Editor:</td>
        <td>Miles Foster-Greenwood</td>
      </tr>
      <tr>
        <td>Re-recording Mixer:</td>
        <td>Lyman Hardy</td>
      </tr>
    </table>
  </secondary-overlay>
</template>

<script>
import SecondaryOverlay from "../components/SecondaryOverlay.vue";
export default {
  components: { SecondaryOverlay },
  methods: {},
};
</script>
<style lang="scss" scoped>
table {
  tr {
    td {
      padding: 4px;
      vertical-align: top;
      &:first-child {
        font-weight: 800;
      }
      &:last-child {
        text-align:right;
      }
    }
  }
}
</style>
